@if (goalInfo?.hasTargetDate) {
  <div bp-goal-detail-card class="" @fadeIn>
    <!-- Encabezado -->
    <div bp-title-card class="tracking-tight truncate">
      Plazo de inversión y progreso
    </div>
    <div class="grid grid-cols-1 gap-3 mt-4">
      <div class="grid grid-cols-2">
        <span class="flex items-center gap-2">
          Plazo de inversión
          <mat-icon
            class=" text-inherit icon-size-4"
            [svgIcon]="'mat_outline:help_outline'"
            matTooltip="Es una estimación del tiempo que tienes pensado en dejar tu dinero invertido. El plazo de inversión puede variar en el tiempo pero tener una estimación de este nos ayuda a entregarte mejores recomendaciones sobre cómo invertir tu dinero y tener expectativas realistas de la rentabilidad final que puedes obtener."
            #plazoInversionTooltip="matTooltip"
            (click)="plazoInversionTooltip.toggle()"
          ></mat-icon>
        </span>
        <span class="flex justify-end"> {{ goal?.years }} años </span>
      </div>
      <div class="grid grid-cols-2">
        <span class="flex items-center gap-2">
          Tiempo transcurrido
          <mat-icon
            class="text-inherit icon-size-4 "
            [svgIcon]="'mat_outline:help_outline'"
          [matTooltip]="
            'Han pasado ' +
            currentlyGoalMonthsFromFirstInvest +
            ' ' +
            monthOrMonths +
            ' desde tu primera inversión en esta meta.'
          "
            #aniosInversionTooltip="matTooltip"
            (click)="aniosInversionTooltip.toggle()"
          ></mat-icon>
        </span>
        <span class="flex justify-end"> {{ currentlyGoalMonths }} meses </span>
      </div>
      <div class="grid grid-cols-2">
        <span class="flex ">
          Monto objetivo
        </span>
        <span class="flex justify-end">
          {{
          goal?.targetAmount
          | currency
          : goal?.currency?.currencyCode
          : goal?.currency?.display
          : goal?.currency?.digitsInfo
          }}
        </span>
      </div>
      <div class="grid grid-cols-2">
        <span class="flex ">
          Progreso
        </span>
        <span class="flex justify-end"> {{ goal?.progress | number: '1.0-1':'es-CL' }}% </span>
      </div>
      <div class="grid grid-cols-1">
        <mat-progress-bar
          class="py-2 rounded-full"
          [color]="'primary'"
          [mode]="'determinate'"
          [value]="(goal?.progress! * 100) / 100"
        ></mat-progress-bar>
        <div class="flex flex-row justify-between">
          <div>{{ goal?.created?.toDate() | date: 'yyyy' }}</div>
          <div>
            {{ goal?.dateOfCompletion | date: 'yyyy' }}
          </div>
        </div>
      </div>
      <div class="grid items-center grid-cols-1 mt-4">
        <span class="flex justify-start">
          @if (goal?.state !== 'portfolioChange') {
            <a bp-link (click)="goToSettings()">
              Ajustar
            </a>
          }
          @if (goal?.state === 'portfolioChange') {
            <a
              class="flex items-center gap-2 cursor-pointer text-secondary disabled"
              matTooltipPosition="above"
          [matTooltip]="
            'Podrás acceder a esta pestaña una vez que el cambio de portafolio se haya realizado.'
          "
              #tooltipPorfolio="matTooltip"
              (click)="tooltipPorfolio.toggle()"
              >
              Ajustar
              <mat-icon
                class="icon-size-4 text-inherit"
                [svgIcon]="'mat_outline:help_outline'"
              ></mat-icon>
            </a>
          }
        </span>
      </div>
    </div>
  </div>
}
